import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import {createPinia} from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import {setCookie1,setCookie2,getCookie,removeCookie} from '@/utils/global'
setCookie1();
setCookie2();
//createApp(App).use(store).use(ElementPlus).use(router).mount('#app')

const app=createApp(App);
//app.config.globalProperties.$cookies=Cookies;
app.use(store);
app.use(createPinia());
app.use(ElementPlus);
app.use(router);

//全局provide
app.provide('$cookies',Cookies);
app.mount('#app');